module.exports = __webpack_public_path__ + "static/media/Mustang 2c.633f75ab.svg";